import bg from "./bg-BG.json"
import cs from "./cs-CZ.json"
import de from "./de-DE.json"
import el from "./el-GR.json"
import en from "./en-US.json"
import es from "./es-ES.json"
import fr from "./fr-FR.json"
import it from "./it-IT.json"
import nl from "./nl-NL.json"
import nb from "./no-NO.json"
import pl from "./pl-PL.json"
import ro from "./ro-RO.json"
import sv from "./sv-SE.json"

export default { en, de, el, es, bg, cs, fr, it, nb, nl, pl, ro, sv }
